import { render, staticRenderFns } from "./RestTable.vue?vue&type=template&id=aecd214c"
import script from "./RestTable.vue?vue&type=script&lang=js"
export * from "./RestTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/wwwroot/node/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('aecd214c')) {
      api.createRecord('aecd214c', component.options)
    } else {
      api.reload('aecd214c', component.options)
    }
    module.hot.accept("./RestTable.vue?vue&type=template&id=aecd214c", function () {
      api.rerender('aecd214c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/RestTable.vue"
export default component.exports